/**
 * Error boundary that catches "Objects are not valid as React child" errors
 * and logs the component stack to help identify the source.
 */
import React from "react";

export class ObjectRenderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "%c[Object Render Error] Component stack - find the component below:",
      "color: red; font-weight: bold"
    );
    console.error(errorInfo.componentStack);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError && this.state.errorInfo) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="font-semibold text-red-800">Render error detected</p>
          <p className="text-sm text-red-700 mt-2">
            Check browser console for component stack. Look for &quot;[Object Render Error]&quot;
          </p>
          <pre className="mt-2 text-xs overflow-auto max-h-40 p-2 bg-white border rounded">
            {this.state.errorInfo.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
